import { useState } from 'react';
import * as React from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
// @mui
import { alpha } from '@mui/material/styles';
import { Box, Divider, Typography, Stack, MenuItem, Button } from '@mui/material';
import { toast } from 'react-toastify';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
// routes
import { PATH_DASHBOARD, PATH_PAGE } from '../../../routes/paths';
import { logoutPartner } from '../../../services/JRMPartnerAuthService';
// hooks
// import {AppAuthContext} from '../../../auth/AppAuthContext';
import {getAuthInfo , removeAuthInfo} from '../../../auth/AppAuthStorage';

// components
import MyAvatar from '../../../components/MyAvatar';
import MenuPopover from '../../../components/MenuPopover';
import { IconButtonAnimate } from '../../../components/animate';
import LanguagePopover from 'src/layouts/header/LanguagePopover';


// ----------------------------------------------------------------------

const MENU_OPTIONS = [
  {
    label: 'Home',
    linkTo: PATH_DASHBOARD.general.myapp,
  },
  {
    label: 'Profile',
    linkTo: PATH_DASHBOARD.user.profile,
  },
  {
    label: 'Change Password',
    linkTo: PATH_DASHBOARD.user.changepassword,
  },
];

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const navigate = useNavigate();
 // const { user, setUser } = useContext (AppAuthContext);
 const user =  localStorage.getItem("country") == 'India' ? localStorage.getItem("mobileNumber") || localStorage.getItem("emailAddress") : localStorage.getItem("emailAddress");
 let fetchData = localStorage.getItem("members");
 fetchData = fetchData ? JSON.parse(fetchData) : {};
let userdata = fetchData.main;
          const [open, setOpen] = useState(null);
          const [open1, setOpen1] = React.useState(false);

          const handleOpen = (event) => {
            setOpen(event.currentTarget);
          };

          const handleClickOpen = () => {
            setOpen1(true);
            
          };
          const handleClickClose = () => {
            setOpen1(false);
          };

          const handleClose = () => {
            setOpen(null);
          };

          const handleLogout = async () => {
            try {
            //  setUser(null);
              
              const authInfo = await getAuthInfo();
              // console.log("authInfo",authInfo);
              const result = await logoutPartner(authInfo
            );
            // console.log("logout result",result);

            if (!result) 
            {
            console.log ("Logout FAILED", result.data);
            return alert (`Unable to logout ${result.data.message}`);
            }
            
            // console.log ("Logout successful", result);
            toast.info ("Logout successful");
            //  Remove all of auth info
             await removeAuthInfo();
            //  Delete the items added in the local storage to logout user
           localStorage.clear();
            navigate(PATH_PAGE.home, { replace: true });
                }
          catch (error) {
                console.error(error);
                toast.error('Unable to logout!', { variant: 'error' });
                }
              };

  return (
    <>
      <IconButtonAnimate
        onClick={handleOpen}
        sx={{
          p: 0,
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
            },
          }),
        }}
      >
        <MyAvatar />
      </IconButtonAnimate>

      <MenuPopover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        sx={{
          p: 0,
          mt: 1.5,
          ml: 0.75,
          '& .MuiMenuItem-root': {
            typography: 'body2',
            borderRadius: 0.75,
          },
        }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="caption" sx={{ color: 'text.secondary' }} noWrap>
            {user}
          </Typography>
          <Typography variant='body2' sx={{ color: 'text.secondary' }} noWrap>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-whatsapp" viewBox="0 0 16 16">
              <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"/>
            </svg>
            {userdata ? " "+userdata.whatsAppNumber : ""}
          </Typography>
        </Box>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <Stack sx={{ p: 0 }}>
          {MENU_OPTIONS.map((option) => (
            <MenuItem
              key={option.label}
              to={option.linkTo}
              component={RouterLink}
              onClick={handleClose}
            >
              {option.label}
            </MenuItem>
          ))}
        </Stack>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <MenuItem onClick={handleClickOpen} sx={{ m: 1 }}>
          Logout
        </MenuItem>
        <Dialog open={open1} onClose={handleClickClose}>
          <DialogTitle>Confirm</DialogTitle>
          <DialogContent>
            <DialogContentText>Are you sure to logout ?</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleLogout}>Logout</Button>
            <Button onClick={handleClickClose}>Cancel</Button>
          </DialogActions>
        </Dialog>
      </MenuPopover>
    </>
  );
}
